'use client';

import { Button, type ButtonProps } from '@jouzen/ecom-components/v3/Button';
import type { PropsWithChildren } from 'react';

export interface TwoColumnModuleCtaProps extends ButtonProps {
  readonly href?: string;
  readonly siteName?: string;
}

const TwoColumnModuleCta = ({
  children,
  ...props
}: PropsWithChildren<TwoColumnModuleCtaProps>) => {
  return (
    <Button {...props} data-cy="two-col-shop-cta">
      {children}
    </Button>
  );
};

export default TwoColumnModuleCta;
